var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrchid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 1764",
    style: {
      enableBackground: "new 0 0 2000 1764"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5F45BA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.7,170.9c-31.9,53.7-101.3,71.4-155,39.5s-71.4-101.3-39.5-155s101.3-71.4,155-39.5c0,0,0,0,0,0 C548.9,47.8,566.6,117.2,534.7,170.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.6,120.7c-22.5,37.9-71.6,50.4-109.5,27.9C1.2,126.1-11.3,77.1,11.2,39.1s71.6-50.4,109.5-27.9 c0,0,0,0,0,0C158.7,33.8,171.2,82.8,148.6,120.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1223.4,1757.7c414.4-48.7,747.7-387.5,774.9-818.7c30.6-485.2-338-903.3-823.2-933.8 c-56.9-3.6-114-1.6-170.5,5.8c-116.6,9.5-215.1,54-215.1,54C709.7,104,658.2,169.2,658.2,256.4c0,113.4,91.9,205.4,205.3,205.4 c19,0,84.6-20.8,100.2-26.2c59.6-20.8,122.8-29.4,185.8-25.3c167.6,10.6,309.3,107,385.2,243.7c44,79.2,64.3,169.3,58.5,259.7 c-16.5,261.5-241.8,460.2-503.4,443.7c-154.5-9.8-287-92.5-366.3-212.4c0,0,0,0.1,0,0.1c0,0,0-0.1,0-0.1 c-94.8-124-72.9-322.3-73-324.8c-3.9-110.3-94.2-198.5-205.4-198.5c-95,0-174.7,64.5-198.4,152c-4.6,17.2-7,67.6-6.3,74.3 c-19.6,476.8,345.3,884.1,823.9,914.2C1117.4,1765.5,1170.6,1764,1223.4,1757.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.9,484.9c-41.4,69.7-131.4,92.6-201,51.2s-92.6-131.4-51.2-201s131.4-92.6,201-51.2c0,0,0,0,0,0 C435.3,325.3,458.2,415.3,416.9,484.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrchid);
export default __webpack_public_path__ + "static/media/orchid.c0064d2c5ae2191975adc28d25423622.svg";
export { ForwardRef as ReactComponent };